export default {
	props: {
		dialogVisible: {
			type: Boolean,
		}
	},
	components: {},
	data() {
		return {
			show: false,
		}
	},
	watch: {
		dialogVisible(val) {
			this.show = val;
		}
	}
}